import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Scissors, Clock, DollarSign } from 'lucide-react';
import { services } from '../../mock';
import { Button } from '../ui/button';

export const ServicesSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-stone-900 mb-4">
            Our Services
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Professional grooming services tailored to your style
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => (
            <Card
              key={service.id}
              className="group border-2 border-stone-200 hover:border-maroon-700 transition-all duration-300 hover:shadow-xl overflow-hidden"
            >
              <div className="h-2 bg-gradient-to-r from-maroon-700 to-maroon-900 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left"></div>
              
              <CardHeader className="space-y-3">
                <div className="bg-stone-700 w-12 h-12 rounded-lg flex items-center justify-center group-hover:bg-maroon-800 transition-colors duration-300">
                  <Scissors className="h-6 w-6 text-maroon-700 group-hover:text-stone-100 transition-colors duration-300" />
                </div>
                <CardTitle className="text-xl text-stone-900">
                  {service.name}
                </CardTitle>
                <CardDescription className="text-stone-600">
                  {service.description}
                </CardDescription>
              </CardHeader>
              
              <CardContent className="space-y-4">
                <div className="flex items-center justify-between text-sm">
                  <div className="flex items-center space-x-2 text-stone-600">
                    <Clock className="h-4 w-4" />
                    <span>{service.duration}</span>
                  </div>
                  <div className="flex items-center space-x-2 text-maroon-800 font-bold text-lg">
                    <DollarSign className="h-5 w-5" />
                    <span>{service.price.replace('$', '')}</span>
                  </div>
                </div>
                
                <Button
                  onClick={scrollToContact}
                  className="w-full bg-stone-700 hover:bg-maroon-800 text-stone-100 transition-colors duration-200"
                >
                  Join Waitlist
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
